if (!customElements.get('product-recommendations')) {
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) {
					return;
				}

				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations');

						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}

						if (html.querySelector('.card')) {
							this.classList.add('product-recommendations-loaded');
						}
                        // price show with VAT
                        if (!document.body.classList.contains('show_vat')) return;
                        const inputs = document.querySelectorAll('.price-update-vat input[type="radio"]');
                        const vatValue = document.body.getAttribute('data-vat');
                      
                        const updateVisibility = () => {
                          inputs.forEach((input) => {
                            if (input.checked) {
                              const nextLabel = input.nextElementSibling;
                              if (nextLabel && nextLabel.tagName.toLowerCase() === 'label') {
                                const labelText = nextLabel.textContent;
                                const vatPrices = document.querySelectorAll('.vat_discount_price');
                                const regularPrices = document.querySelectorAll('.withou_vat');
                                if (vatValue && labelText.includes(vatValue)) {
                                  vatPrices.forEach(el => el.style.display = 'block');
                                  regularPrices.forEach(el => el.style.display = 'none');
                                } else {
                                  vatPrices.forEach(el => el.style.display = 'none');
                                  regularPrices.forEach(el => el.style.display = 'block');
                                }
                              }
                            }
                          });
                        };
                      
                        updateVisibility();
                        inputs.forEach((input) => {
                          input.addEventListener('change', updateVisibility);
                        });
					})
					.catch(error => {
						console.error(error);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
}
